import styled from 'styled-components';

import { BREAK_POINTS, COLOURS } from '../../consts/style';

export const FindPlanContainer = styled.section`
  padding: 32px 20px;
  box-sizing: border-box;
  overflow: auto;
  max-width: 1140px;
  background: white;
  width: 100%;

  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    display: flex;
    padding: 32px 0px;
  }

  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    align-items: center;
    min-height: 320px;
  }
`;

export const FindPlanInner = styled.div`
  display: inline-block;
  margin: 0 auto;
  @media (min-width: ${BREAK_POINTS.MIN.XS}) {
    max-width: 222px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    max-width: 300px;
  }
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    min-width: 294px;
  }
`;

export const PostCodeLabel = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 12px;

  @media (max-width: ${BREAK_POINTS.MIN.SM}) {
    display: none;
  }
`;

export const PostCodeInput = styled.input`
  display: block;
  border: none;
  border-bottom: 4px solid ${COLOURS.GREY.GREY_16};
  width: 4.3em;
  padding-left: 3px;
  height: 60px;
  box-sizing: border-box;
  padding: 0;

  font-size: 56px;
  letter-spacing: 24px;

  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }

  &:focus {
    outline: none;
    color: black;
  }

  ::placeholder {
    color: ${COLOURS.GREY.GREY_16};
    font-weight: 500;
  }

  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    font-size: 56px;
    height: 66px;
    box-sizing: border-box;
    padding-right: 1px;
    padding-top: 1px;
    padding-bottom: 1px;
  }
` as any;
